<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<svelte:head>
  <title>Signup Confirmed - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  <header>
    <h2>Welcome to Outlive!</h2>
  </header>

  <p>
    Your email has been confirmed and you are now subscribed to progress notifications.
  </p>
  <p>
    You will receive an email whenever your ranking changes (i.e., when you outlive a pope or antipope).
  </p>
  <p>
    <a href="/" class="button" on:click|preventDefault={() => navigate('/')}>Return to home</a>
  </p>
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #main > header:first-child {
    text-align: center;
  }

  @media screen and (max-width: 736px) {
    #main {
      padding: 2em;
    }
  }
</style>
